/**
 * After a redeploy an open tab can keep an index.html pointing at assets that no longer
 * exist. When an asset with a build hash fails to load, reload once to pick up the new build.
 */
const FLAG = '_sm_asset_reload';

export function installAssetRecovery() {
  window.addEventListener('error', (event) => {
    const el = event?.target;
    if (!el || !(el.tagName === 'SCRIPT' || el.tagName === 'LINK')) return;
    const url = el.src || el.href || '';
    if (!/\/static\/(js|css)\//.test(url)) return;
    if (sessionStorage.getItem(FLAG)) return;
    sessionStorage.setItem(FLAG, '1');
    window.location.reload();
  }, true);

  window.addEventListener('load', () => sessionStorage.removeItem(FLAG));
}
